import {Component, Injector, Input, OnInit, ViewEncapsulation} from '@angular/core';
import { ReplaceKeywordsPipe } from 'projects/common/pipes/replace-keywords.pipe';
import {AbstractComponent} from '../abstract.component';

export interface BreadcrumbData {
  link: string;
  path: string;
  text: string;
}

@Component({
  selector: 'breadcrumb-component',
  template: `
    <div class="eva-3-breadcrumb">
      <ol class="breadcrumb-container" itemscope itemtype="https://schema.org/BreadcrumbList">
        <li *ngFor="let item of data; let index = index" class="breadcrumb-item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <a *ngIf="item.link" class="breadcrumb-text eva-3-link" [href]="item.link" itemprop="item">
            <span itemprop="name">{{item.text}}</span>
          </a>
          <span *ngIf="!item.link" class="breadcrumb-text" itemprop="name">{{item.text}}</span>
          <meta [content]="index" itemprop="position"/>
        </li>
      </ol>
    </div>
  `,
  styleUrls: ['./breadcrumb.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BreadcrumbComponent extends AbstractComponent implements OnInit {

  @Input() data: BreadcrumbData[];

  constructor(injector: Injector, private replaceKeywordPipe: ReplaceKeywordsPipe) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.data) {
      // @ts-ignore
      this.data = this.data
        .map(breadcrumb => this.replaceKeywordPipe.transform(breadcrumb, this.keywordsMap))
        .filter(breadcrumb => breadcrumb.text);
    }
  }

  getModuleId(): string {
    return 'BreadcrumbComponent';
  }
}
